import React from 'react';
import ReferenceInput, { getChildrenProps } from './ReferenceInput';
import { AutocompleteInput } from 'react-admin';
import InputUtils from 'utils/input';

const JobInput = (props) => (
  <ReferenceInput {...props}>
    <AutocompleteInput
      optionText={InputUtils.optionText('id')}
      {...getChildrenProps(props)}
      data-testid="job-input"
    />
  </ReferenceInput>
);

JobInput.defaultProps = {
  label: 'Job ID',
  source: 'job_id',
  reference: 'Job',
  sort: { field: 'id', order: 'ASC' },
  perPage: 25,
  fullWidth: false,
};

export default JobInput;
